export class Todo {
    constructor(public text: string) {
    }
}



// WEBPACK FOOTER //
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/app/shared/todo/index.ts